module.exports = __webpack_public_path__ + "static/img/dp_qr.9e09ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/dp_qr.png
// module id = kcBn
// module chunks = 0